import React, { Component } from "react";
import * as utils from "common/utils";
import * as cu from "containers/BudgetHome/Crops/_utils";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import PanelBody from "components/Panel/PanelBody";
import Alert from "components/Alert";
import { Line } from "react-chartjs-2";

class NPoolsGraph extends Component {
    render() {
        const { block } = this.props;

        const results = block.currentResults || {};
        const showNPools = results.nPools && Object.keys(results.nPools).length > 0;
        const showChangeInNPools = results.changeInNPools && Object.keys(results.changeInNPools).length > 0;

        const NPoolsGraph = ({ poolData, block }) => {
            const year = cu.rotationYear(block, true);
            const nData = {
                labels: year,
                datasets: Object.keys(poolData).map((k, i) => ({
                    label: poolData[k].label,
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: "rgba(75,192,192,0.4)",
                    borderColor: utils.graphColours[i],
                    data: year.map((m, i) => {
                        return year.length > 12 && i < 12 ? poolData[k].previousResults && poolData[k].previousResults[m] : poolData[k].results[m];
                    }),
                })),
            };

            const options = {
                scales: {
                    y: {
                        title: {
                            display: true,
                            text: "kg N/ha",
                        },
                    },
                },
            };

            return <Line data={nData} legend={{ display: true }} height={75} options={options} />;
        };

        return (
            <PanelBody>
                <Alert className="u-print-none" type="info" text="These are the N pool and change in N pool graphs for the background model. You can click on each of the labels (eg. Plant uptake label) to add or remove it from the graph." />
                <Grid>
                    {showNPools && (
                        <GridCell className="u-xl-width1of1">
                            <h3>Nitrogen pools</h3>
                            <NPoolsGraph poolData={results.nPools} block={block} />
                        </GridCell>
                    )}
                    {showChangeInNPools && (
                        <GridCell className="u-xl-width1of1">
                            <h3>Change in nitrogen pools</h3>
                            <NPoolsGraph poolData={results.changeInNPools} block={block} />
                        </GridCell>
                    )}
                </Grid>
            </PanelBody>
        );
    }
}

export default NPoolsGraph;
